import React, { Component } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { TweenMax } from 'gsap';
import Draggable from "gsap/Draggable";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { animateScroll as scroll } from 'react-scroll';

import {
  Wrapper,
  Plane,
} from './style';

import Tooltip from '../Tooltip';
import IntroCloudItems from '../IntroCloudItems';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';

class IntroCloud extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
      scale: 0.25,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.initDraggable)
    this.initDraggable();

    autorun(() => {
      const item = IntroCloudState.activeItem;
      const filtering = IntroCloudState.resultsAreFiltered;
      if (item) {
        const itemX = 1 - ((item.position.x - (IntroCloudState.containerWidth / 2)) / (IntroCloudState.width - IntroCloudState.containerWidth));
        const itemY = 1 - ((item.position.y - (IntroCloudState.containerHeight / 2)) / (IntroCloudState.height - IntroCloudState.containerHeight)); 
        const x = ((IntroCloudState.maxX - IntroCloudState.minX) * (itemX)) + IntroCloudState.minX;
        const y = ((IntroCloudState.maxY - IntroCloudState.minY) * (itemY)) + IntroCloudState.minY;
        TweenMax.to(this.draggableEl, 0.5, { x: x, y: y });
        setTimeout(() => this.setState({ scale: 1 }), 500);
      } else if (filtering) {
        TweenMax.to(this.draggableEl, 0.5, { x: IntroCloudState.initialX, y: IntroCloudState.initialY });
        setTimeout(() => this.setState({ scale: 0.125 }), 500);
      } else {
        this.setState({ scale: 0.25 });
      }
    });
  }

  componentDidUpdate(oldProps) {
    if (this.props.children !== oldProps.children) this.initDraggable();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.initDraggable)
    clearTimeout(this.initTimeout);
  }

  initDraggable = () => {
    if (this.wrapperEl && this.draggableEl) {
      this.resetDraggable();
    } else {
      this.initTimeout = setTimeout(this.initDraggable, 100);
    }
  }

  resetDraggable = () => {
    if (AppState.regularMode) {
      const onDrag = function() {
        const offsetX = 1 - ((this.x - this.minX) / (this.maxX - this.minX));
        const offsetY = 1 - ((this.y - this.minY) / (this.maxY - this.minY));
        IntroCloudState.offsetX = isNaN(offsetX) ? 0 : offsetX;
        IntroCloudState.offsetY = isNaN(offsetY) ? 0 : offsetY;
      };

      TweenMax.set(this.draggableEl, {
        x: IntroCloudState.initialX,
        y: IntroCloudState.initialY,
      });

      IntroCloudState.offsetX = 0.5;
      IntroCloudState.offsetY = 0.5;

      this.draggable = Draggable.create(this.draggableEl, {
        bounds: {
          maxY: IntroCloudState.maxY,
          minY: IntroCloudState.minY,
          maxX: IntroCloudState.maxX,
          minX: IntroCloudState.minX,
        },
        cursor: 'grab',
        dragClickables: true,
        edgeResistance: 0.65,
        maxDuration: 1.5,
        minimumMovement: 6,
        overshootTolerance: 0.4,
        throwProps: true,
        throwResistance: 100,
        type: 'x,y',
        zIndexBoost: false,
        onPress: () => {
          IntroCloudState.dragging = true;
          IntroCloudState.showHelper = false;
          IntroCloudState.introActive = false;
          if (AppState.scrollTop > 0) scroll.scrollTo(0);
        },
        onRelease: () => {
          IntroCloudState.dragging = false;
        },
        onDrag: onDrag,
        onThrowUpdate: onDrag,
        onThrowComplete: onDrag,
      });
    } else {
      this.draggableEl.style.transform = `translate3D(-43.75%, -44%, 0)`;
    }
  }

  render() {
    return (
      <Wrapper
        innerRef={(el) => this.wrapperEl = el}
        style={{
          display: AppState.scrollTop <= AppState.windowHeight * 2 ? 'block' : 'none',
          transform: `scale(${this.state.scale}) translate3D(0,0,0)`,
        }}
      >
        <Plane
          className={IntroCloudState.dragging ? 'dragging' : ''}
          innerRef={(el) => this.draggableEl = el}
          style={{
            height: IntroCloudState.height,
            width: IntroCloudState.width,
          }}
        >
          <IntroCloudItems />
        </Plane>
      </Wrapper>
    );
  }
}

export default observer(IntroCloud);



// WEBPACK FOOTER //
// ./src/components/IntroCloud/index.js